const removeDuplicateFromArrayOfObjectByField = (arr, field) => {
  const uniqueValuesSet = new Set();

  return arr.filter((obj) => {
    const isPresentInSet = uniqueValuesSet.has(obj[field]);

    uniqueValuesSet.add(obj[field]);

    return !isPresentInSet;
  });
};

export default removeDuplicateFromArrayOfObjectByField;
